// document.ready()
$(() => {
  $(document).on('click', '[data-open]', function () {
    var target = $(this).attr('data-open');
    var targetElement = '.' + target;
    var activeClass = target + '--active';

    if ($(targetElement).hasClass(activeClass)) {
      $(targetElement).removeClass(activeClass);

      if ($(this).data('closed-title')) {
        $(this).text($(this).data('closed-title'));
      }

      return false;
    }

    $(targetElement).addClass(activeClass);

    if ($(this).data('openend-title')) {
      $(this).text($(this).data('openend-title'));
    }
  });

  // tippy(document.querySelectorAll('.icon-info[data-tooltip]'), {
  //   arrow: false,
  //   placement: 'bottom',
  //   theme: 'brok',
  //   interactive: true,
  // });

  tippy.delegate('body', {
    target: '.icon-info[data-tooltip]',
    arrow: false,
    placement: 'bottom',
    theme: 'brok',
    interactive: true,
  });

  // Start Kiyoh Widget //
  const url = 'https://feedback.monkeydo.it/api/v1/review/brok-bouwmaterialen';
  const cacheKey = 'kiyohData';

  const cachedData = sessionStorage.getItem(cacheKey);

  if (cachedData) {
    const data = JSON.parse(cachedData);
    displayKiyohData(data);
    generateStructuredData(data);
  } else {
    fetch(url)
      .then((response) => response.json())
      .then((data) => {
        sessionStorage.setItem(cacheKey, JSON.stringify(data));
        displayKiyohData(data);
        generateStructuredData(data);
      })
      .catch((error) => console.error('Error fetching data:', error));
  }

  function displayKiyohData(data) {
    const score = data.ratings.average;
    const quantity = data.ratings.quantity;
    const kiyohUrl = data.urls.view;
    const roundHalf = Math.round(score) / 2 + '';
    const stars = roundHalf.split('.');
    const fullStars = parseInt(stars[0]);
    let halfStars = stars[1] == 5 ? 1 : 0;
    const emptyStars = 5 - (fullStars + halfStars);

    document.querySelectorAll('[data-kiyoh-stars]').forEach((container) => {
      container.innerHTML = '';

      for (let i = 0; i < fullStars; i++) {
        const fullStar = document.createElement('i');
        fullStar.className = 'icon icon-star-filled';
        container.appendChild(fullStar);
      }

      for (let i = 0; i < halfStars; i++) {
        const halfStar = document.createElement('i');
        halfStar.className = 'icon icon-star-half';
        container.appendChild(halfStar);
      }

      for (let i = 0; i < emptyStars; i++) {
        const emptyStar = document.createElement('i');
        emptyStar.className = 'icon icon-star-empty';
        container.appendChild(emptyStar);
      }
    });

    if (document.querySelector('.product__reviews--stars')) {
      document
        .querySelector('.product__reviews--stars')
        .setAttribute('aria-label', `Customer Rating: ${roundHalf.replace('.', ',')} out of 5 stars`);
    }

    document.querySelectorAll('[data-kiyoh-score]').forEach((el) => {
      el.innerHTML = score.replace('.', ',');
    });

    document.querySelectorAll('[data-kiyoh-stars-quantity]').forEach((el) => {
      el.innerHTML = roundHalf.replace('.', ',');
    });

    document.querySelectorAll('[data-kiyoh-link]').forEach((el) => {
      el.setAttribute('href', kiyohUrl);
    });

    document.querySelectorAll('[data-kiyoh-quantity]').forEach((el) => {
      el.innerHTML = quantity;
    });
  }

  function generateStructuredData(data) {
    const ratingValue = (parseFloat(data.ratings.average) / 2).toFixed(1); // Convert from 1-10 to 1-5 scale
    const structuredData = {
      '@context': 'https://schema.org',
      '@type': 'AggregateRating',
      itemReviewed: {
        '@type': 'Organization',
        name: 'Brok Bouwmaterialen',
      },
      ratingValue: ratingValue,
      bestRating: '5',
      worstRating: '1',
      reviewCount: data.ratings.quantity,
      url: data.urls.view,
    };

    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.textContent = JSON.stringify(structuredData);
    document.head.appendChild(script);
  }
  // End Kiyoh Widget //

  // Desktop sticky menu
  function updateHeaderGroupWrapTop() {
    if ($(window).width() > 992) {
      var topbarHeight = $('.header-group-wrap .topbar').outerHeight() || 0;
      var headerHeight = $('.header-group-wrap .header').outerHeight() || 0;
      var totalHeight = topbarHeight + headerHeight;

      $('.header-group-wrap').css('top', -totalHeight + 'px');
    } else {
      $('.header-group-wrap').css('top', '');
    }
  }

  updateHeaderGroupWrapTop();

  $(window).on('resize', function () {
    updateHeaderGroupWrapTop();
  });
});

// Mobile menu

document.querySelectorAll('.mobile-menu__open-subs').forEach(function (toggleButton) {
  toggleButton.addEventListener('click', function () {
    const submenu = toggleButton.closest('li').querySelector('.mobile-menu__submenu');
    submenu.classList.toggle('mobile-menu__submenu--active');
  });
});

document.querySelectorAll('.mobile-menu__submenu-title').forEach(function (submenuTitle) {
  submenuTitle.addEventListener('click', function () {
    const submenu = submenuTitle.closest('ul').classList.contains('mobile-menu__submenu')
      ? submenuTitle.closest('ul')
      : null;
    if (submenu) {
      submenu.classList.remove('mobile-menu__submenu--active');
    }
  });
});

window.addEventListener('load', function () {
  const sectionHeaders = document.querySelectorAll('.shopify-section-group-header-group');

  let totalHeight = 0;
  sectionHeaders.forEach((header) => {
    totalHeight += header.offsetHeight;
  });

  const mobileMenu = document.querySelector('.mobile-menu');
  if (mobileMenu) {
    // console.log(totalHeight);
    mobileMenu.style.top = totalHeight + 'px';
    mobileMenu.style.height = `calc(100vh - ${totalHeight}px)`;
  }
});
// document.addEventListener('change', function (event) {
//   // Controleer of de gebeurtenis afkomstig is van een select in de juiste container
//   if (event.target.matches('.native-select select')) {
//     const selectElement = event.target;
//     const selectedText = selectElement.options[selectElement.selectedIndex].text;
//     const nativeSelectContainer = selectElement.closest('.native-select');
//     const selectedPlaceholder = nativeSelectContainer.querySelector('.native-select__placeholder');

//     console.log(selectedPlaceholder);

//     if (selectedPlaceholder) {
//       selectedPlaceholder.textContent = selectedText;
//       selectedPlaceholder.classList.add('native-select__placeholder--chosen');
//     }
//   }
// });

document.addEventListener('DOMContentLoaded', function () {
  // Functie om de placeholder te updaten
  // 1. Event delegation for dynamically injected selects
  document.addEventListener('change', function (event) {
    if (event.target.matches('.native-select select')) {
      updatePlaceholder(event.target);
    }
  });

  // 2. Execute the same logic for existing selects on pageload
  document.querySelectorAll('.native-select select').forEach(function (selectElement) {
    updatePlaceholder(selectElement);
  });

  // Mega menu

  const showMoreLinks = document.querySelectorAll('.mega-menu-list__linklist-item--show');

  showMoreLinks.forEach((link) => {
    link.addEventListener('click', function () {
      const list = this.closest('.mega-menu-list__linklist');
      const plusItems = list.querySelectorAll('.mega-menu-list__linklist-item--plus');
      const showMoreLink = list.querySelector('.mega-menu-list__linklist-item--show-more');
      const showLessLink = list.querySelector('.mega-menu-list__linklist-item--show-less');

      plusItems.forEach((item) => {
        item.classList.toggle('show');
      });

      if (showMoreLink.style.display === 'none') {
        showMoreLink.style.display = 'block';
        showLessLink.style.display = 'none';
      } else {
        showMoreLink.style.display = 'none';
        showLessLink.style.display = 'block';
      }
    });
  });

  // Mega menu overlay

  const megaMenu = document.querySelectorAll('.mega-menu');
  const mainMenuLi = document.querySelectorAll('.main-menu__li');
  const overlay = document.querySelector('.mega-menu__overlay');

  // console.log('megaMenu', megaMenu);
  // console.log('mainMenuLi', mainMenuLi);
  // console.log('overlay', overlay);

  function openMenuOverlay() {
    overlay.classList.add('mega-menu__overlay--open');
  }

  function closeMenuOverlay() {
    overlay.classList.remove('mega-menu__overlay--open');
  }

  mainMenuLi.forEach((item) => {
    item.addEventListener('mouseenter', openMenuOverlay);
    item.addEventListener('mouseleave', closeMenuOverlay);

    if (!item.querySelector('div')) {
      item.removeEventListener('mouseenter', openMenuOverlay);
    }
  });

  // Fix: Loop through the NodeList and add event listeners
  megaMenu.forEach((item) => {
    item.addEventListener('mouseenter', openMenuOverlay);
    item.addEventListener('mouseleave', closeMenuOverlay);
  });
});

function updatePlaceholder(selectElement) {
  const selectedOption = selectElement.options[selectElement.selectedIndex];
  const selectedText = selectedOption.text;
  const nativeSelectContainer = selectElement.closest('.native-select');
  const selectedPlaceholder = nativeSelectContainer?.querySelector('.native-select__placeholder');
  const isUpsell = document.querySelector('.cart__upsells');
  const upsellItem = selectElement.closest(isUpsell ? '.product-tile' : '.upsell-products__item');
  const priceElement = upsellItem?.querySelector(
    `${isUpsell ? '.product-tile__price' : '.upsell-products__item-price'} span[data-price]`
  );
  const priceFrom = upsellItem?.querySelector('.price--from');

  if (selectedOption.hasAttribute('value') && selectedOption.value !== '') {
    const selectedOptionPrice = selectedOption.getAttribute('data-variant-price');

    if (priceElement && selectedOptionPrice) {
      priceElement.textContent = window.Shopmonkey.formatMoney(selectedOptionPrice);
      priceElement.setAttribute('data-price', selectedOptionPrice);

      if (priceFrom) {
        priceFrom.classList.add('d-none');
      }
    }
  }

  if (selectedPlaceholder) {
    selectedPlaceholder.textContent = selectedText;

    if (selectedOption.disabled) {
      selectedPlaceholder.classList.remove('native-select__placeholder--chosen');
    } else {
      selectedPlaceholder.classList.add('native-select__placeholder--chosen');
    }
  }
}

window.Shopmonkey = window.Shopmonkey || {};

window.Shopmonkey.formatMoney = function (amount) {
  const moneyFormat = window.cartStrings.moneyFormat || '{{amount}}';

  const formattedAmount = (amount / 100).toFixed(2);
  const parts = formattedAmount.split('.');
  let integerPart = parts[0];
  const decimalPart = parts[1];

  integerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, '.');

  if (0 >= parseFloat(formattedAmount)) {
    return 'gratis';
  }

  return moneyFormat
    .replace('{{amount}}', `${integerPart},${decimalPart}`)
    .replace('{{amount_with_comma_separator}}', `${integerPart},${decimalPart}`)
    .replace('{{amount_no_decimals}}', integerPart);
};

window.onload = function () {
  const urlParams = new URLSearchParams(window.location.search);
  const y = urlParams.get('y');

  if (y && !isNaN(y)) {
    window.scrollTo({
      top: parseInt(y),
      behavior: 'smooth',
    });
  }
};
